(function () {
  "use strict";

  var DESKTOP = "(min-width: 900px)";

  function destroy(swiper) {
    if (swiper) {
      swiper.destroy(true, true);
    }
  }

  function getSidePadPx(root) {
    var raw = getComputedStyle(root)
      .getPropertyValue("--sv-swi-pad")
      .trim();
    if (!raw) {
      return 20;
    }
    var n = parseFloat(raw);
    return n === n ? n : 20;
  }

  function makeSwiper(root) {
    var el = root.querySelector(".sv-steps-with-images__swiper");
    if (!el) return;

    if (el.querySelectorAll(".swiper-slide").length < 1) return;

    var sidePad = getSidePadPx(root);

    return new window.Swiper(el, {
      slidesPerView: 1.35,
      spaceBetween: 20,
      slidesOffsetBefore: sidePad,
      slidesOffsetAfter: sidePad,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      centeredSlides: false,
      grabCursor: true,
      navigation: {
        nextEl: root.querySelector(
          ".sv-steps-with-images__nav-next"
        ),
        prevEl: root.querySelector(
          ".sv-steps-with-images__nav-prev"
        )
      },
      pagination: {
        el: root.querySelector(".sv-steps-with-images__pagination"),
        clickable: true
      },
      breakpoints: {
        600: {
          slidesPerView: 2.5,
          spaceBetween: 20,
          slidesOffsetBefore: sidePad,
          slidesOffsetAfter: sidePad,
        }
      }
    });
  }

  function bind(root) {
    var inst = null;
    var mq = window.matchMedia(DESKTOP);

    function apply() {
      if (typeof window.Swiper === "undefined") return;

      if (mq.matches) {
        destroy(inst);
        inst = null;
      } else {
        destroy(inst);
        inst = makeSwiper(root);
      }
    }

    apply();
    if (typeof mq.addEventListener === "function") {
      mq.addEventListener("change", apply);
    } else {
      mq.addListener(apply);
    }
  }

  function initAll() {
    document
      .querySelectorAll(".sv-steps-with-images")
      .forEach(bind);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
